import React from "react";

const SvgFacebook = ({ color, ...props }) => (
  <svg width={6} viewBox="0 0 6 12" {...props}>
    <path
      d="M4.089 11.99v-5.4h1.638l.268-2.4H4.089V3.03c0-.62.016-1.23.879-1.23h.874V.08A9.365 9.365 0 0 0 4.331 0c-1.586 0-2.58.99-2.58 2.81v1.38H0v2.4h1.753v5.4h2.338z"
      fill={color || "currentColor"}
      fillRule="evenodd"
    />
  </svg>
);

export default SvgFacebook;
